import { BadgeColor } from '@billy/design-system'

import { QuoteState } from '../../../enums/quoteState'

export const quotesStateToBadgeColor: Record<QuoteState, BadgeColor> = {
  [QuoteState.All]: 'neutral',
  [QuoteState.Open]: 'accent',
  [QuoteState.Closed]: 'danger',
}
